"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WS_TIMEOUT = void 0;
var WS_TIMEOUT = 30000;
exports.WS_TIMEOUT = WS_TIMEOUT;
//# sourceMappingURL=defaults.js.map